import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetLocationClustersParams } from './types'
import type { ClusterDto } from './dtos'

const URL = '/location/clusters/'

export const getClusters: AblePaginatedResponseFn<GetLocationClustersParams, ClusterDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
